module.exports = __webpack_public_path__ + "img/95.9.TU.7fcc8e03.png";